import { DEFAULT_LOCALE } from '@/constants'

export const getLanguageAlternates = (link: string) => {
	const envDomain = process.env.NEXT_PUBLIC_HOST as string
	const locales = process.env.NEXT_ALLOWED_LOCALIZATION?.split(',') ?? []
	return [
		...locales.map((locale) => ({
			hrefLang: locale,
			href: `${envDomain}${locale !== DEFAULT_LOCALE ? `/${locale}` : ''}${link || ''}`,
		})),
	]
}
